import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { Typography } from '@one-thd/sui-atomic-components';
import classNames from 'classnames/bind';
import styles from './emt-description.scss';

const cx = classNames.bind(styles);

export const EmtDescription = ({ title, description, useDefaultFontStylesForHeadings }) => {

  const classes = cx('emt-description__description-text sui-text-primary', {
    'emt-description__revert-font-styles-for-headings': useDefaultFontStylesForHeadings
  });
  return (
    <div data-component="EmtDescription">
      <Typography variant="h3" color="primary" weight="bold">{title}</Typography>
      <div className={classes}>
        <ReactMarkdown>{description}</ReactMarkdown>
      </div>
    </div>
  );
};

EmtDescription.displayName = 'EmtDescription';

EmtDescription.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  useDefaultFontStylesForHeadings: PropTypes.bool
};

EmtDescription.defaultProps = {
  useDefaultFontStylesForHeadings: false
};